var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4002_3234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1144 51.8619C19.253 52.3964 22.8637 54.0771 25.4202 56.3926C25.9556 56.8775 25.7562 58.4214 25.1152 58.7543C22.0544 60.3444 18.1352 61.0528 13.9966 60.5183C9.85793 59.9839 6.2473 58.3032 3.69079 55.9877C3.15536 55.5028 3.35479 53.9589 3.99578 53.6259C7.05656 52.0358 10.9757 51.3275 15.1144 51.8619Z",
    fill: "url(#paint0_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1144 51.8619C19.253 52.3964 22.8637 54.0771 25.4202 56.3926C25.9556 56.8775 25.7562 58.4214 25.1152 58.7543C22.0544 60.3444 18.1352 61.0528 13.9966 60.5183C9.85793 59.9839 6.2473 58.3032 3.69079 55.9877C3.15536 55.5028 3.35479 53.9589 3.99578 53.6259C7.05656 52.0358 10.9757 51.3275 15.1144 51.8619Z",
    fill: "url(#paint1_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5982 46.0665C20.0243 47.9854 23.4967 51.0087 25.5951 54.3991C26.0344 55.1092 25.3186 56.7602 24.5 56.9249C20.591 57.7111 16.0107 57.2429 11.5848 55.3241C7.1587 53.4053 3.68629 50.3821 1.58794 46.9915C1.14858 46.2815 1.86437 44.6304 2.68296 44.4657C6.59198 43.6797 11.1722 44.1477 15.5982 46.0665Z",
    fill: "url(#paint2_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5982 46.0665C20.0243 47.9854 23.4967 51.0087 25.5951 54.3991C26.0344 55.1092 25.3186 56.7602 24.5 56.9249C20.591 57.7111 16.0107 57.2429 11.5848 55.3241C7.1587 53.4053 3.68629 50.3821 1.58794 46.9915C1.14858 46.2815 1.86437 44.6304 2.68296 44.4657C6.59198 43.6797 11.1722 44.1477 15.5982 46.0665Z",
    fill: "url(#paint3_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5678 36.763C25.3406 41.2494 25.6583 45.8427 24.7445 49.7238C24.5531 50.5367 22.8794 51.198 22.1842 50.7355C18.8642 48.5272 15.9564 44.9575 14.1836 40.4711C12.4109 35.9846 12.0931 31.3914 13.007 27.5102C13.1983 26.6974 14.872 26.0361 15.5672 26.4985C18.8872 28.7067 21.795 32.2764 23.5678 36.763Z",
    fill: "url(#paint4_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5678 36.763C25.3406 41.2494 25.6583 45.8427 24.7445 49.7238C24.5531 50.5367 22.8794 51.198 22.1842 50.7355C18.8642 48.5272 15.9564 44.9575 14.1836 40.4711C12.4109 35.9846 12.0931 31.3914 13.007 27.5102C13.1983 26.6974 14.872 26.0361 15.5672 26.4985C18.8872 28.7067 21.795 32.2764 23.5678 36.763Z",
    fill: "url(#paint5_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1076 36.9316C21.6205 40.9889 24.5549 45.9826 25.7031 50.8655C25.9436 51.888 24.4301 53.5716 23.3878 53.4409C18.4107 52.8168 13.134 50.4286 8.62108 46.3712C4.10814 42.314 1.17377 37.3202 0.0254944 32.4374C-0.214976 31.4148 1.29853 29.7312 2.34085 29.8619C7.31785 30.486 12.5946 32.8744 17.1076 36.9316Z",
    fill: "url(#paint6_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09302 37.9856C3.62821 40.9746 5.82045 43.8534 8.62127 46.3715C13.1342 50.4287 18.4108 52.8171 23.388 53.4412C24.4303 53.5718 25.9438 51.8884 25.7033 50.8657C24.5551 45.9829 21.6207 40.9891 17.1077 36.9319C14.4504 34.5427 11.5279 32.733 8.558 31.5208L2.09302 37.9856Z",
    fill: "url(#paint7_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8856 51.8619C50.747 52.3964 47.1363 54.0771 44.5798 56.3926C44.0444 56.8775 44.2438 58.4214 44.8848 58.7543C47.9456 60.3444 51.8648 61.0528 56.0034 60.5183C60.1421 59.9839 63.7527 58.3032 66.3092 55.9877C66.8446 55.5028 66.6452 53.9589 66.0042 53.6259C62.9434 52.0358 59.0243 51.3275 54.8856 51.8619Z",
    fill: "url(#paint8_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8856 51.8619C50.747 52.3964 47.1363 54.0771 44.5798 56.3926C44.0444 56.8775 44.2438 58.4214 44.8848 58.7543C47.9456 60.3444 51.8648 61.0528 56.0034 60.5183C60.1421 59.9839 63.7527 58.3032 66.3092 55.9877C66.8446 55.5028 66.6452 53.9589 66.0042 53.6259C62.9434 52.0358 59.0243 51.3275 54.8856 51.8619Z",
    fill: "url(#paint9_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4018 46.0665C49.9757 47.9854 46.5033 51.0087 44.405 54.3991C43.9656 55.1092 44.6814 56.7602 45.5 56.9249C49.409 57.7111 53.9893 57.2429 58.4152 55.3241C62.8413 53.4053 66.3137 50.3821 68.4121 46.9915C68.8514 46.2815 68.1356 44.6304 67.3171 44.4657C63.408 43.6797 58.8278 44.1477 54.4018 46.0665Z",
    fill: "url(#paint10_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4018 46.0665C49.9757 47.9854 46.5033 51.0087 44.405 54.3991C43.9656 55.1092 44.6814 56.7602 45.5 56.9249C49.409 57.7111 53.9893 57.2429 58.4152 55.3241C62.8413 53.4053 66.3137 50.3821 68.4121 46.9915C68.8514 46.2815 68.1356 44.6304 67.3171 44.4657C63.408 43.6797 58.8278 44.1477 54.4018 46.0665Z",
    fill: "url(#paint11_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4322 36.763C44.6594 41.2494 44.3417 45.8427 45.2555 49.7238C45.4468 50.5367 47.1205 51.198 47.8157 50.7355C51.1358 48.5272 54.0435 44.9575 55.8163 40.4711C57.5891 35.9846 57.9068 31.3914 56.993 27.5102C56.8017 26.6974 55.128 26.0361 54.4328 26.4985C51.1127 28.7067 48.205 32.2764 46.4322 36.763Z",
    fill: "url(#paint12_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4322 36.763C44.6594 41.2494 44.3417 45.8427 45.2555 49.7238C45.4468 50.5367 47.1205 51.198 47.8157 50.7355C51.1358 48.5272 54.0435 44.9575 55.8163 40.4711C57.5891 35.9846 57.9068 31.3914 56.993 27.5102C56.8017 26.6974 55.128 26.0361 54.4328 26.4985C51.1127 28.7067 48.205 32.2764 46.4322 36.763Z",
    fill: "url(#paint13_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8923 36.9316C48.3794 40.9889 45.445 45.9826 44.2967 50.8655C44.0563 51.888 45.5698 53.5716 46.6121 53.4409C51.5892 52.8168 56.8659 50.4286 61.3788 46.3712C65.8917 42.314 68.8261 37.3202 69.9744 32.4374C70.2149 31.4148 68.7013 29.7312 67.659 29.8619C62.682 30.486 57.4053 32.8744 52.8923 36.9316Z",
    fill: "url(#paint14_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9069 37.9856C66.3717 40.9746 64.1795 43.8534 61.3787 46.3715C56.8657 50.4287 51.5891 52.8171 46.612 53.4412C45.5697 53.5718 44.0561 51.8884 44.2966 50.8657C45.4449 45.9829 48.3793 40.9891 52.8922 36.9319C55.5496 34.5427 58.472 32.733 61.4419 31.5208L67.9069 37.9856Z",
    fill: "url(#paint15_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 69.9999C47.0547 69.9999 56.8271 60.2276 56.8271 48.1728C56.8271 36.118 47.0547 26.3457 35 26.3457C22.9452 26.3457 13.1729 36.118 13.1729 48.1728C13.1729 60.2276 22.9452 69.9999 35 69.9999Z",
    fill: "url(#paint16_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 65.5706C44.6084 65.5706 52.3977 57.7814 52.3977 48.1729C52.3977 38.5644 44.6084 30.7751 34.9999 30.7751C25.3914 30.7751 17.6022 38.5644 17.6022 48.1729C17.6022 57.7814 25.3914 65.5706 34.9999 65.5706Z",
    fill: "url(#paint17_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 63.109C43.2489 63.109 49.936 56.4219 49.936 48.1729C49.936 39.9239 43.2489 33.2368 34.9999 33.2368C26.751 33.2368 20.0638 39.9239 20.0638 48.1729C20.0638 56.4219 26.751 63.109 34.9999 63.109Z",
    fill: "url(#paint18_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1729 48.1728C13.1729 60.2276 22.9451 69.9999 35 69.9999C47.0548 69.9999 56.8271 60.2276 56.8271 48.1728C56.8271 48.0881 56.8249 48.004 56.8239 47.9194H13.176C13.175 48.004 13.1729 48.0881 13.1729 48.1728Z",
    fill: "url(#paint19_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1216 69.1285C47.9993 67.1227 53.4722 61.8239 55.7195 55.0527L45.0887 44.4219L42.6921 44.5396L36.2238 38.0713L28.3406 56.3475L41.1216 69.1285Z",
    fill: "url(#paint20_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9501 43.43L39.6695 42.3958C39.2713 42.2996 38.9234 42.0581 38.6937 41.7188L36.2262 38.0713C35.9276 37.6301 35.4704 37.3934 34.9999 37.3552C34.5294 37.3934 34.0721 37.6301 33.7737 38.0713L31.3061 41.7188C31.0766 42.0581 30.7287 42.2996 30.3304 42.3958L26.0498 43.43C24.8886 43.7105 24.4048 45.0964 25.1389 46.0388L27.8454 49.5127C28.0971 49.836 28.2193 50.2414 28.1877 50.6499L27.8485 55.0405C27.7566 56.2315 28.925 57.1201 30.0482 56.713L34.1885 55.2125C34.4501 55.1177 34.7291 55.0932 34.9999 55.1352C35.2709 55.0934 35.5498 55.1178 35.8114 55.2125L39.9517 56.713C41.0747 57.1199 42.2433 56.2315 42.1513 55.0405L41.8122 50.6499C41.7806 50.2414 41.9028 49.836 42.1545 49.5127L44.861 46.0388C45.5951 45.0964 45.1112 43.7105 43.9501 43.43Z",
    fill: "url(#paint21_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8114 55.2125L39.9517 56.713C41.0748 57.1199 42.2434 56.2315 42.1514 55.0405L41.8122 50.6499C41.7807 50.2414 41.9028 49.8359 42.1546 49.5127L44.8611 46.0388C45.5953 45.0965 45.1113 43.7105 43.9501 43.43L39.6695 42.3958C39.2714 42.2996 38.9234 42.0581 38.6938 41.7188L36.2262 38.0713C35.9277 37.6301 35.4705 37.3934 35 37.3552V55.1352C35.2709 55.0932 35.55 55.1177 35.8114 55.2125Z",
    fill: "url(#paint22_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.95 43.43L39.6694 42.3958C39.5233 42.3605 39.3841 42.3052 39.2549 42.2332L28.3429 56.3475C28.771 56.7612 29.4168 56.9419 30.0482 56.7131L34.1884 55.2127C34.4501 55.1178 34.7291 55.0934 34.9999 55.1354C35.2708 55.0935 35.5497 55.118 35.8113 55.2127L39.9516 56.7131C41.0747 57.1201 42.2432 56.2316 42.1513 55.0407L41.8121 50.65C41.7806 50.2416 41.9027 49.8361 42.1544 49.5129L44.861 46.039C45.595 45.0964 45.1112 43.7106 43.95 43.43Z",
    fill: "url(#paint23_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0498 43.43L30.3304 42.3958C30.4766 42.3605 30.6157 42.3052 30.7449 42.2332L41.6569 56.3475C41.2288 56.7612 40.5831 56.9419 39.9517 56.7131L35.8114 55.2127C35.5498 55.1178 35.2707 55.0934 34.9999 55.1354C34.729 55.0935 34.4501 55.118 34.1885 55.2127L30.0482 56.7131C28.9252 57.1201 27.7566 56.2316 27.8485 55.0407L28.1877 50.65C28.2193 50.2416 28.0971 49.8361 27.8454 49.5129L25.1389 46.039C24.4048 45.0964 24.8886 43.7106 26.0498 43.43Z",
    fill: "url(#paint24_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9104 44.4219C24.7069 44.9352 24.7558 45.547 25.1388 46.0387L27.8454 49.5127C28.0971 49.8359 28.2193 50.2413 28.1877 50.6498L27.8485 55.0405C27.7566 56.2314 28.925 57.12 30.0482 56.7129L34.1885 55.2124C34.4501 55.1176 34.7291 55.0932 34.9999 55.1352C35.2709 55.0933 35.5498 55.1177 35.8114 55.2124L39.9517 56.7129C41.0747 57.1199 42.2433 56.2314 42.1513 55.0405L41.8122 50.6498C41.7946 50.4232 41.826 50.198 41.899 49.9867L24.9104 44.4219Z",
    fill: "url(#paint25_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0911 44.4219C45.2946 44.9352 45.2459 45.547 44.8627 46.0387L42.1561 49.5127C41.9044 49.8359 41.7823 50.2413 41.8138 50.6498L42.153 55.0405C42.2449 56.2314 41.0763 57.12 39.9533 56.7129L35.813 55.2124C35.5514 55.1176 35.2724 55.0932 35.0016 55.1352C34.7306 55.0933 34.4517 55.1177 34.1901 55.2124L30.0498 56.7129C28.9268 57.1199 27.7582 56.2314 27.8502 55.0405L28.1893 50.6498C28.2069 50.4232 28.1755 50.198 28.1025 49.9867L45.0911 44.4219Z",
    fill: "url(#paint26_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 26.3457C34.9093 26.3457 34.8194 26.348 34.7291 26.3491L31.3606 29.7176L55.9513 54.3084C56.5204 52.3618 56.827 50.3031 56.827 48.1727C56.827 36.118 47.0547 26.3457 34.9999 26.3457Z",
    fill: "url(#paint27_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8234 0.45752V11.9869L34.9998 25.1634L48.1763 11.9869V0.45752H21.8234Z",
    fill: "url(#paint28_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8234 0.45752V4.04564L34.9558 17.178C34.9801 17.2023 35.0196 17.2023 35.0439 17.178L48.1763 4.04564V0.45752H21.8234Z",
    fill: "url(#paint29_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8234 0.45752V4.04564L34.9558 17.178C34.9801 17.2023 35.0196 17.2023 35.0439 17.178L48.1763 4.04564V0.45752H21.8234Z",
    fill: "url(#paint30_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 19.2542C34.4566 19.2542 33.9135 19.0475 33.5001 18.634L21.8234 6.95728V11.9871L34.9998 25.1636L48.1763 11.9871V6.95728L36.4996 18.634C36.0862 19.0474 35.5431 19.2542 34.9998 19.2542Z",
    fill: "url(#paint31_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 19.2542C34.4566 19.2542 33.9135 19.0475 33.5001 18.634L21.8234 6.95728V11.9871L34.9998 25.1636L48.1763 11.9871V6.95728L36.4996 18.634C36.0862 19.0474 35.5431 19.2542 34.9998 19.2542Z",
    fill: "url(#paint32_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 19.2542C35.5431 19.2542 36.0862 19.0475 36.4996 18.634L48.1763 6.95728V11.9871L34.9998 25.1636L21.8234 11.9871V6.95728L33.5001 18.634C33.9135 19.0474 34.4567 19.2542 34.9998 19.2542Z",
    fill: "url(#paint33_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.555 22.1704L22.3421 10.9575C21.5013 10.1167 20.1379 10.1167 19.2971 10.9575C18.4563 11.7983 18.4563 13.1617 19.2971 14.0025L34.9999 29.7056L50.7028 14.0027C51.5437 13.1618 51.5437 11.7985 50.7028 10.9577C49.862 10.1168 48.4987 10.1168 47.6578 10.9577L36.4449 22.1706C35.6468 22.9686 34.353 22.9686 33.555 22.1704Z",
    fill: "url(#paint34_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.297 10.9831L33.3466 25.0326C34.2597 25.9458 35.7403 25.9458 36.6535 25.0326L50.7029 10.9831C50.707 10.9789 50.7103 10.9744 50.7144 10.9703C50.7104 10.9662 50.707 10.9616 50.7029 10.9575C49.8621 10.1167 48.4987 10.1167 47.6579 10.9575L36.445 22.1704C35.647 22.9684 34.3531 22.9684 33.5551 22.1704L22.3422 10.9575C21.5014 10.1167 20.138 10.1167 19.2972 10.9575C19.2931 10.9616 19.2898 10.9662 19.2856 10.9703C19.2896 10.9744 19.2929 10.9789 19.297 10.9831Z",
    fill: "url(#paint35_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 29.7057L46.0844 18.6211H39.9943L36.4448 22.1706C35.6468 22.9686 34.3528 22.9686 33.5548 22.1706L30.0053 18.6211H23.9152L34.9999 29.7057Z",
    fill: "url(#paint36_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6273 28.3331L34.9999 29.7057L49.0583 15.6472H42.9682L36.4449 22.1705C35.6701 22.9453 34.4294 22.9655 33.6273 22.236V28.3331Z",
    fill: "url(#paint37_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 31.2252C37.8423 31.2252 40.1466 28.9209 40.1466 26.0784C40.1466 23.2359 37.8423 20.9316 34.9998 20.9316C32.1573 20.9316 29.853 23.2359 29.853 26.0784C29.853 28.9209 32.1573 31.2252 34.9998 31.2252Z",
    fill: "url(#paint38_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 29.0291C36.6294 29.0291 37.9505 27.708 37.9505 26.0784C37.9505 24.4488 36.6294 23.1277 34.9998 23.1277C33.3701 23.1277 32.0491 24.4488 32.0491 26.0784C32.0491 27.708 33.3701 29.0291 34.9998 29.0291Z",
    fill: "url(#paint39_linear_4002_3234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1668 5.12414H19.8329C18.9613 5.12414 18.2548 4.41755 18.2548 3.54598V1.57816C18.2548 0.706588 18.9613 0 19.8329 0H50.1669C51.0384 0 51.745 0.706588 51.745 1.57816V3.54612C51.745 4.41769 51.0384 5.12414 50.1668 5.12414Z",
    fill: "url(#paint40_linear_4002_3234)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4002_3234",
    x1: 9.98133,
    y1: 49.8834,
    x2: 14.5107,
    y2: 56.1285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4002_3234",
    x1: 9.56887,
    y1: 53.8886,
    x2: 16.7061,
    y2: 57.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4002_3234",
    x1: 5.33541,
    y1: 44.5602,
    x2: 12.8158,
    y2: 50.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4002_3234",
    x1: 8.47141,
    y1: 50.7779,
    x2: 14.1446,
    y2: 50.6865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4002_3234",
    x1: 20.3636,
    y1: 31.7728,
    x2: 18.6479,
    y2: 39.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4002_3234",
    x1: 12.9499,
    y1: 32.5677,
    x2: 17.342,
    y2: 37.0512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4002_3234",
    x1: 10.3117,
    y1: 33.6684,
    x2: 14.0862,
    y2: 45.4723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4002_3234",
    x1: 11.0722,
    y1: 40.0962,
    x2: 15.9219,
    y2: 44.3054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4002_3234",
    x1: 60.0185,
    y1: 49.8834,
    x2: 55.4891,
    y2: 56.1285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4002_3234",
    x1: 60.4311,
    y1: 53.8886,
    x2: 53.2939,
    y2: 57.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4002_3234",
    x1: 64.6646,
    y1: 44.5602,
    x2: 57.1842,
    y2: 50.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4002_3234",
    x1: 61.5286,
    y1: 50.7779,
    x2: 55.8554,
    y2: 50.6865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4002_3234",
    x1: 49.6364,
    y1: 31.7728,
    x2: 51.3521,
    y2: 39.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4002_3234",
    x1: 57.0501,
    y1: 32.5677,
    x2: 52.6579,
    y2: 37.0512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4002_3234",
    x1: 59.6882,
    y1: 33.6684,
    x2: 55.9137,
    y2: 45.4723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4002_3234",
    x1: 58.9277,
    y1: 40.0962,
    x2: 54.0781,
    y2: 44.3054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4002_3234",
    x1: 21.5427,
    y1: 34.7155,
    x2: 44.5625,
    y2: 57.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4002_3234",
    x1: 46.2996,
    y1: 59.4725,
    x2: 23.3706,
    y2: 36.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4002_3234",
    x1: 24.1418,
    y1: 37.3148,
    x2: 42.0147,
    y2: 55.1877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4002_3234",
    x1: 35,
    y1: 54.559,
    x2: 35,
    y2: 68.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4002_3234",
    x1: 48.0725,
    y1: 59.5165,
    x2: 30.0462,
    y2: 48.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4002_3234",
    x1: 30.4532,
    y1: 44.024,
    x2: 38.6523,
    y2: 52.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4002_3234",
    x1: 39.9128,
    y1: 46.2595,
    x2: 28.5806,
    y2: 50.9443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4002_3234",
    x1: 36.9539,
    y1: 50.2811,
    x2: 30.7497,
    y2: 47.6221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4002_3234",
    x1: 33.046,
    y1: 50.2811,
    x2: 39.2502,
    y2: 47.6221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4002_3234",
    x1: 33.1839,
    y1: 50.5922,
    x2: 37.1723,
    y2: 44.1822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4002_3234",
    x1: 36.5102,
    y1: 49.7826,
    x2: 36.1779,
    y2: 43.5152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4002_3234",
    x1: 45.7558,
    y1: 38.9517,
    x2: 37.3375,
    y2: 24.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4002_3234",
    x1: 35.976,
    y1: 7.77911,
    x2: 41.3976,
    y2: 16.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4002_3234",
    x1: 30.5683,
    y1: -2.83015,
    x2: 47.4049,
    y2: 16.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4002_3234",
    x1: 34.9998,
    y1: 9.1275,
    x2: 34.9998,
    y2: 4.59342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4002_3234",
    x1: 26.9917,
    y1: 0.288883,
    x2: 43.8282,
    y2: 19.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4002_3234",
    x1: 40.2148,
    y1: 14.6871,
    x2: 42.5578,
    y2: 17.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4002_3234",
    x1: 29.7848,
    y1: 14.6871,
    x2: 27.4419,
    y2: 17.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4002_3234",
    x1: 46.898,
    y1: 24.3782,
    x2: 18.7525,
    y2: -3.76732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4002_3234",
    x1: 35,
    y1: 11.2092,
    x2: 35,
    y2: 30.4303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4002_3234",
    x1: 34.9999,
    y1: 22.3727,
    x2: 34.9999,
    y2: 28.6924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4002_3234",
    x1: 41.4875,
    y1: 18.7943,
    x2: 37.6444,
    y2: 22.7061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4002_3234",
    x1: 32.0488,
    y1: 23.1274,
    x2: 39.3275,
    y2: 30.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4002_3234",
    x1: 37.8821,
    y1: 28.9607,
    x2: 31.0637,
    y2: 22.1423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4002_3234",
    x1: 34.9999,
    y1: 1.55551,
    x2: 34.9999,
    y2: 4.41563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4002_3234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold-medal.8bf94c931bce2df3e19023d5d0e3b5f9.svg";
export { ForwardRef as ReactComponent };